export { rtiTranslations } from '../locales';
